
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  BulkProductTableRowData,
  CustomsPacking,
  CustomsPackingGroup,
  HqPackingListDetail,
  ProductInfo,
  SecondaryPacking,
  SecondaryPackingInfo,
  TableRowData
} from "@/model/HqPackingListModels";
import { getCustomsGroups } from "@/api/customs-packing";
import { Table } from "element-ui";
import {downloadHqPackingList} from "@/api/hq-packing-list";
import {downloadFiles} from "@/utils/oss-download";

@Component({
  name: "HqPackingListProductList"
})

export default class extends Vue {
  @Prop({ required: true }) private hqPackingListDetail: HqPackingListDetail;
  @Prop({ required: false, default: false }) private requireSelection: boolean;
  @Prop({ required: false, default: false }) private showPackageActions: boolean;
  @Prop({ required: false, default: false }) private showCustomsPackingState: boolean;
  @Prop({ required: false, default: false }) private showActionColumn: boolean;
  @Prop({ required: false, default: false }) private showHandleEdit: boolean;
  @Prop({ required: false, default: false }) private productQuantityEditable: boolean;

  private tableDataList: TableRowData[] = [];
  private productInfos: BulkProductTableRowData[] = [];
  private customsPackingIds: TableRowData[] = [];

  private handleProductSelectionChange(rows) {
    this.$emit("product-selection-changed", rows);
  }

  private handleSelectionChange(rows) {
    this.$emit("selection-changed", rows, this.hqPackingListDetail.id);
  }

  private handleGroupedSelectionChange(rows: TableRowData[], group: string[]) {
    this.$emit("grouped-selection-changed", rows, group);
  }

  private getPackageInfoShow() {
    if(
        this.$route.meta.buttonCodes &&
        Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes("editProductQuantity") && this.productQuantityEditable;
    }
  }

  private editPackageInfo(row: TableRowData) {
    this.$emit("edit-package-info-management", row.customsPackingId);
  }

  private handleDeleteCustomsPacking(row: TableRowData) {
    this.$emit("delete-customs-packing", row.customsPackingId);
  }

  private handleDeleteProduct(row: BulkProductTableRowData) {
    this.$emit("delete-product", row.id);
  }

  private confirmEdit(row: TableRowData) {
    this.$emit("edit-product-number", row.productId, row.totalPcs);
  }

  private confirmSecondaryEdit(row: TableRowData) {
    this.$emit("edit-secondary-number", row.secondaryPackingId, row.ctnQuantity);
  }

  private confirmEditBulkProduct(row: BulkProductTableRowData) {
    this.$emit("edit-product-number", row.id, row.totalNumberPcs);
  }

  private getRowKeys(row) {
    return row.id;
  }

  private cancelEdit(row: TableRowData) {
    row.isEdit = false;
    row.totalPcs = row.originTotalPcs;
  }

  private cancelSecondaryEdit(row: TableRowData) {
    row.isSecondaryPackingEdit = false;
    row.ctnQuantity = row.originCtnQuantity;
  }

  private async showGrouped(row) {
    if (row.groupId !== null) {
      row.optionalPopoverVisible = true;
      const details: any = await getCustomsGroups(row.groupId);
      row.customsPackingGroups = details;
    }
  }

  private cancelGrouped(row) {
    (this.$refs.customsPackingTable as Table).toggleRowSelection(row, false);
    row.customsPackingGroups.map((row) => {
      (this.$refs.groupedTable as Table).toggleRowSelection(row, false);
    });
    row.optionalPopoverVisible = false;
    this.customsPackingIds = [];
  }

  private handleGroupedSelectConfirm(row) {
    (this.$refs.customsPackingTable as Table).toggleRowSelection(row, this.customsPackingIds.length !== 0);
    const groups: string[] = [];
    row.customsPackingGroups.map((grouped) => {
      groups.push(grouped);
    });
    this.handleGroupedSelectionChange(this.customsPackingIds, groups);
    row.optionalPopoverVisible = false;
  }

  private handleGroupedCustomsPackingSelection(rows: CustomsPackingGroup[]) {
    const ids: TableRowData[] = [];
    for (let i = 0; i < rows.length; i++) {
      let tableRowData: TableRowData = new TableRowData();
      tableRowData.id = rows[i].id;
      ids.push(tableRowData);
    }
    this.customsPackingIds = ids;
  }

  @Watch("hqPackingListDetail", { deep: true, immediate: true })
  private convertData(detail: HqPackingListDetail) {
    if (!detail) {
      this.tableDataList = [];
      this.productInfos = [];
      return;
    }
    const tableRowDataList: TableRowData[] = [];
    const customsPackingList: CustomsPacking[] = detail.customsPackingSet;
    for (let i = 0; i < customsPackingList?.length; i++) {
      const customsPacking: CustomsPacking = customsPackingList[i];
      const secondaryPackingList: SecondaryPacking[] = customsPacking.secondaryPackingSet;
      const customsRowData: TableRowData[] = [];
      let totalRows = 0;
      for (let j = 0; j < secondaryPackingList.length; j++) {
        // const productInfoList: ProductInfo[] = secondaryPackingList[j].productInfos;
        const productInfoList: ProductInfo[] = secondaryPackingList[j].packingInfos.map(value => value.productInfos).reduce((pre, cur) => pre.concat(cur), []);
        for (let k = 0; k < productInfoList.length; k++) {
          const productInfo: ProductInfo = productInfoList[k];
          const secondaryPackingRows = k === 0 ? productInfoList.length : 0;
          totalRows += secondaryPackingRows;
          const tableRowData = this.buildTableData(productInfo, secondaryPackingList[j], customsPacking, secondaryPackingRows);
          customsRowData.push(tableRowData);
          tableRowDataList.push(tableRowData);
        }
      }
      if (customsRowData.length !== 0) {
        customsRowData[0].customsPackingRows = totalRows;
      }
    }
    this.tableDataList = tableRowDataList;
    this.productInfos = this.hqPackingListDetail?.productInfos?.map(productInfo => {
      let bulkProductTableRowData: BulkProductTableRowData = { ...productInfo, isEdit: false, popoverVisible: false };
      return bulkProductTableRowData;
    });
  }

  private buildTableData(productInfo: ProductInfo, secondaryPacking: SecondaryPacking,
                         customsPacking: CustomsPacking, secondaryPackingRows: number): TableRowData {
    let tableRowData: TableRowData = new TableRowData();
    tableRowData.isEdit = false;
    tableRowData.isSecondaryPackingEdit = false;
    tableRowData.popoverVisible = false;
    tableRowData.customsPackingId = customsPacking.id;
    tableRowData.code = customsPacking.code;
    tableRowData.ackType = customsPacking.ackTypeDesc;
    tableRowData.customsPackingState = customsPacking.stateDesc;
    tableRowData.productId = productInfo.id;
    tableRowData.productName = productInfo.description;
    tableRowData.customsName = productInfo.declarationDescription;
    tableRowData.customerModel = productInfo.guestModel;
    tableRowData.hAndQNumber = productInfo.hqOrJrNumber;
    tableRowData.oeNumber = productInfo.oeNumber;
    tableRowData.refNumber = productInfo.refNumber;
    tableRowData.hqTransactionNumber = productInfo.hqTransactionNumber;
    tableRowData.totalPcs = productInfo.totalNumberPcs;
    tableRowData.originTotalPcs = productInfo.totalNumberPcs;
    tableRowData.purchaseOrderNumber = productInfo.batch === null ? productInfo.purchaseOrderNumber :
        productInfo.purchaseOrderNumber + "(" + productInfo.batch + ")";
    tableRowData.unitPrice = productInfo.unitPrice;
    tableRowData.poNumber = productInfo.poNumber;
    tableRowData.remark = productInfo.remark;
    tableRowData.secondaryPackingId = secondaryPacking.id;
    tableRowData.ctnQuantity = secondaryPacking.cartonNumber;
    tableRowData.originCtnQuantity = secondaryPacking.cartonNumber;
    tableRowData.confirmedStateDesc = customsPacking.confirmedStateDesc;
    tableRowData.problemType = customsPacking.problemType;

    if (secondaryPacking.packingInfos.length === 1) {
      // 次包装可选信息合并行
      // tableRowData.ctnGrossWeight = secondaryPacking.packingInfos[0].grossWeightPerCarton;
      // tableRowData.cntWeight = secondaryPacking.packingInfos[0].netWeight;
      // tableRowData.ctnLength = secondaryPacking.packingInfos[0].length;
      // tableRowData.ctnWidth = secondaryPacking.packingInfos[0].width;
      // tableRowData.ctnHeight = secondaryPacking.packingInfos[0].height;

      tableRowData.ctnGrossWeight = secondaryPacking.packingInfos[0]?.packingWeight?.grossWeight;
      tableRowData.cntWeight = secondaryPacking.packingInfos[0]?.packingWeight?.netWeight;
      tableRowData.ctnLength = secondaryPacking.packingInfos[0]?.packingVolume?.length;
      tableRowData.ctnWidth = secondaryPacking.packingInfos[0]?.packingVolume?.width;
      tableRowData.ctnHeight = secondaryPacking.packingInfos[0]?.packingVolume?.height;
      tableRowData.secondaryPackingOptionalInfoRows = secondaryPackingRows;
    } else {
      for (let i = 0; i < secondaryPacking.packingInfos.length; i++) {
        const info: SecondaryPackingInfo = secondaryPacking.packingInfos[i];
        if (info.id === productInfo.parentId) {
          if ( info.productInfos.length > 1 && productInfo.id === info.productInfos[0].id){
              tableRowData.secondaryPackingOptionalInfoRows = info.productInfos.length;
          } else {
            if (info.productInfos.length > 1){
              if (info.productInfos[0].id !== productInfo.id) {
                tableRowData.secondaryPackingOptionalInfoRows = 0;
              }
            }else{
              tableRowData.secondaryPackingOptionalInfoRows = 1;
            }
          }
          tableRowData.ctnGrossWeight = info?.packingWeight?.grossWeight;
          tableRowData.cntWeight = info?.packingWeight?.netWeight;
          tableRowData.ctnLength = info?.packingVolume?.length;
          tableRowData.ctnWidth = info?.packingVolume?.width;
          tableRowData.ctnHeight = info?.packingVolume?.height;
        }
      }
    }
    tableRowData.id = customsPacking.id;
    tableRowData.groupId = customsPacking.groupId;
    tableRowData.grossWeight = customsPacking.grossWeight;
    tableRowData.netWeight = customsPacking.netWeight;
    tableRowData.length = customsPacking.length;
    tableRowData.width = customsPacking.width;
    tableRowData.height = customsPacking.height;
    tableRowData.secondaryPackingRows = secondaryPackingRows;
    tableRowData.customsPackingRows = 0;
    tableRowData.optionalPopoverVisible = false;
    tableRowData.showPopover = tableRowData.groupId !== null;
    tableRowData.customsPackingGroups = [];
    return tableRowData;
  }

  private arraySpanMethod({ row, columnIndex }) {
    if (this.isSecondaryPackageColumn(columnIndex)) {
      if (row.secondaryPackingRows < 1) {
        return [0, 0];
      } else if (row.secondaryPackingRows > 1) {
        return [row.secondaryPackingRows, 1];
      }
    }

    if (this.isCustomsPackageColumn(columnIndex)) {
      if (row.customsPackingRows < 1) {
        return [0, 0];
      } else if (row.customsPackingRows > 1) {
        return [row.customsPackingRows, 1];
      }
    }

    if (this.isSecondaryPackingOptionalInfoColumn(columnIndex)) {
      if (row.secondaryPackingOptionalInfoRows < 1) {
        return [0, 0];
      } else if (row.secondaryPackingOptionalInfoRows > 1) {
        return [row.secondaryPackingOptionalInfoRows, 1];
      }
    }

    if (this.isOptionalColumn(columnIndex)) {
      if (row.customsPackingRows < 1) {
        return [0, 0];
      } else if (row.customsPackingRows > 1) {
        return [row.customsPackingRows, 1];
      }
    }

    // 编辑包装信息的按钮
    if (this.isEditPackageColumn(columnIndex)) {
      if (row.customsPackingRows < 1) {
        return [0, 0];
      } else if (row.customsPackingRows > 1) {
        return [row.customsPackingRows, 1];
      }
    }
  }

  private isEditPackageColumn(column: number) {
    let offset = 0;
    if (this.requireSelection) {
      offset = 1;
    }
    return column === 23 + offset;
  }

  private isCustomsPackageColumn(column: number) {
    let offset = 0;
    if (this.requireSelection) {
      offset = 1;
    }
    return column >= 0 && column < 8 + offset;
  }

  private handleEdit() {
    this.$emit('handleEdit')
  }

  private isSecondaryPackageColumn(column: number) {
    if (this.requireSelection) {
      column = column - 1;
    }
    return column == 8;
  }

  private isSecondaryPackingOptionalInfoColumn(column: number) {
    if (this.requireSelection) {
      column = column - 1;
    }
    return column >= 9 && column < 14;
  }

  private isOptionalColumn(column: number) {
    if (this.requireSelection) {
      return column == 24;
    }
    // else {
    //     return column == 23;
    //   }
  }

  private showRowPopover(row: TableRowData) {
    this.tableDataList.map(value => value.popoverVisible = false);
    row.popoverVisible = true;
  }

  private showBulkProductDeletePopover(row: BulkProductTableRowData) {
    this.productInfos.map(value => value.popoverVisible = false);
    row.popoverVisible = true;
  }

  private async doDownload() {
    const response: any = await downloadHqPackingList({
      hqPackingListIds: [this.hqPackingListDetail.id],
    });
    const resultUrl: string[] = response;
    if (resultUrl.length > 0) {
      downloadFiles(resultUrl);
    }
  }
}

